import Vue, { DirectiveOptions } from 'vue'
import App from './App.vue'
import router from './router'
import ELEMENT from 'element-ui'
import '@/styles/index.less';
import '@/permission';
import * as filters from './utils/filter'
import * as directives from '@/directives'
import Fragment from 'vue-fragment'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(ELEMENT)
Vue.use(Fragment.Plugin)
Vue.use(VueQuillEditor)

Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key])
})

// Register global directives
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key])
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
